import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Generic skeleton component for ingestion step loading states.
 * Displays a header area followed by 3 form field placeholders.
 */
export const IngestionStepSkeleton = () => {
  return (
    <div className="space-y-2 p-2">
      {/* Header skeleton */}
      <div className="space-y-1">
        <Skeleton className="h-5 w-48" />
        <Skeleton className="h-4 w-64" />
      </div>

      {/* Form fields skeleton */}
      <Card className="p-6">
        <div className="space-y-4">
          {/* Field 1 */}
          <div className="space-y-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-10 w-full" />
          </div>

          {/* Field 2 */}
          <div className="space-y-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-10 w-full" />
          </div>

          {/* Field 3 */}
          <div className="space-y-2">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-10 w-full" />
          </div>
        </div>
      </Card>
    </div>
  );
};
